import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import Logo from '../common/Logo';
import { waGeneral, SUPPORT_PHONE_DISPLAY } from '../../utils/support';

const ECOSYSTEM_SITES = [
  { href: 'https://blog.eidoc.com.br', label: 'blog.eidoc.com.br', description: 'Blog sobre marketing, inovação e tecnologia para médicos.' },
  { href: 'https://minimental.com.br', label: 'minimental.com.br', description: 'Calculadora online do Mini Exame do Estado Mental (MEEM).' },
  { href: 'https://hemograma.online', label: 'hemograma.online', description: 'Apoio à interpretação de hemograma e exames laboratoriais.' },
  { href: 'https://savp.online', label: 'savp.online', description: 'Material de Suporte Avançado de Vida em Pediatria (SAVP).' },
  { href: 'https://links.doctor', label: 'links.doctor', description: 'Página profissional com um único link para quem tem CRM/CRMV.' },
];

const Footer = () => {
  return (
    <footer className="bg-navy text-white pt-16 pb-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <Logo dark markClassName="h-9 w-9" />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Plataforma para profissionais de saúde elaborarem, organizarem e emitirem seus próprios laudos.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-6 text-white/80">Produto</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/modelos-laudo" className="text-white/60 hover:text-white transition-colors">Modelos de laudos</Link></li>
              <li><Link to="/referencias-laudos" className="text-white/60 hover:text-white transition-colors">Referências de laudos</Link></li>
              <li><Link to="/software-para-laudos-medicos" className="text-white/60 hover:text-white transition-colors">Software para laudos</Link></li>
              <li><Link to="/como-funciona" className="text-white/60 hover:text-white transition-colors">Como funciona</Link></li>
              <li><Link to="/planos" className="text-white/60 hover:text-white transition-colors">Planos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-6 text-white/80">Institucional</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/sobre" className="text-white/60 hover:text-white transition-colors">Sobre o Laudando</Link></li>
              <li><Link to="/seguranca" className="text-white/60 hover:text-white transition-colors">Segurança</Link></li>
              <li><Link to="/privacidade" className="text-white/60 hover:text-white transition-colors">Privacidade</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-6 text-white/80">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={waGeneral()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors"
                >
                  WhatsApp {SUPPORT_PHONE_DISPLAY}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 pb-10">
          <h4 className="font-semibold text-sm mb-6 text-white/80 text-center">Nosso ecossistema</h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {ECOSYSTEM_SITES.map((site) => (
              <li key={site.href}>
                <a
                  href={site.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col gap-1.5 h-full p-4 rounded-card border border-white/10 hover:border-white/30 hover:bg-white/5 transition-colors"
                >
                  <span className="flex items-center gap-1.5 text-sm font-semibold text-white group-hover:underline">
                    {site.label}
                    <ExternalLink className="w-3.5 h-3.5 text-white/50" aria-hidden="true" />
                  </span>
                  <span className="text-white/60 text-xs leading-relaxed">{site.description}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t border-white/10 pt-8 text-center space-y-4">
          <p className="text-white/50 text-[11px] leading-relaxed max-w-2xl mx-auto">
            O Laudando auxilia profissionais de saúde na elaboração, organização e emissão de seus próprios laudos, com QR Code, hash de integridade e validação online.
            A plataforma não emite assinatura digital ICP-Brasil.
          </p>
          <p className="text-white/50 text-xs">© 2026 Laudando Online. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;